import { Box, Stack, Typography } from '@mui/material';

const statusAccent = {
  complete: { dot: 'success.main', line: 'success.light' },
  active: { dot: 'secondary.main', line: 'divider' },
  upcoming: { dot: 'divider', line: 'divider' },
};

function JourneyStepper({ steps }) {
  return (
    <Stack spacing={2.5}>
      {steps.map((step, index) => {
        const accent = statusAccent[step.status] || statusAccent.upcoming;
        const isLast = index === steps.length - 1;

        return (
          <Stack key={step.title} direction="row" spacing={2}>
            <Stack alignItems="center" sx={{ minWidth: 18 }}>
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: '50%',
                  bgcolor: accent.dot,
                  mt: 0.5,
                }}
              />
              {!isLast ? (
                <Box
                  sx={{
                    width: 2,
                    flex: 1,
                    bgcolor: accent.line,
                    minHeight: 48,
                    mt: 0.75,
                  }}
                />
              ) : null}
            </Stack>
            <Box sx={{ pb: isLast ? 0 : 1 }}>
              <Typography fontWeight={700}>{step.title}</Typography>
              <Typography color="text.secondary" variant="body2">
                {step.description}
              </Typography>
            </Box>
          </Stack>
        );
      })}
    </Stack>
  );
}

export default JourneyStepper;
